var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipPlatinumMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1618_59813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6876 2.02998L21.4286 9.08012C20.8687 9.62389 20.119 9.92806 19.3385 9.92806H12.4444C10.7876 9.92806 9.44444 11.2712 9.44444 12.9281V20.2664C9.44444 21.1053 9.09313 21.906 8.47574 22.474L3.33533 27.2038C2.06734 28.3705 2.04045 30.363 3.27649 31.5635L9.33522 37.4479C9.96825 38.0627 10.2985 38.925 10.2381 39.8054L9.66447 48.1615C9.54547 49.8951 10.9197 51.3669 12.6574 51.3669H21.0712C21.8784 51.3669 22.6515 51.6922 23.2159 52.2692L28.7378 57.9144C29.8735 59.0755 31.7271 59.1219 32.9195 58.019L39.2487 52.1646C39.8032 51.6518 40.5306 51.3669 41.2858 51.3669H50C51.6569 51.3669 53 50.0238 53 48.3669V39.5518C53 38.8207 53.267 38.1148 53.7507 37.5667L59.1074 31.497C60.167 30.2964 60.0969 28.4754 58.9483 27.3598L53.9099 22.4664C53.3282 21.9015 53 21.1252 53 20.3144V12.9281C53 11.2712 51.6569 9.92806 50 9.92806H42.2171C41.4366 9.92806 40.6868 9.62389 40.1269 9.08012L32.8679 2.02998C31.7038 0.899394 29.8517 0.899396 28.6876 2.02998Z",
    fill: "url(#paint0_linear_1618_59813)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91 34H8.39V31.37H9.38C10.97 31.37 12.23 30.62 12.23 28.93C12.23 27.17 10.97 26.6 9.34 26.6H6.91V34ZM8.39 30.2V27.78H9.23C10.25 27.78 10.79 28.06 10.79 28.93C10.79 29.77 10.3 30.2 9.28 30.2H8.39ZM13.5799 34H18.0699V32.76H15.0599V26.6H13.5799V34ZM18.3037 34H19.8038L20.8638 30.15C21.0838 29.38 21.2938 28.53 21.4938 27.73H21.5338C21.7438 28.52 21.9538 29.38 22.1738 30.15L23.2338 34H24.7838L22.4138 26.6H20.6738L18.3037 34ZM19.7738 32.1H23.2938V30.96H19.7738V32.1ZM26.3097 34H27.7897V27.83H29.8797V26.6H24.2197V27.83H26.3097V34ZM31.0897 34H32.5697V26.6H31.0897V34ZM34.3905 34H35.7905V31.04C35.7905 30.18 35.6705 29.25 35.6005 28.46H35.6505L36.4005 30.04L38.5405 34H40.0505V26.6H38.6405V29.55C38.6405 30.39 38.7605 31.38 38.8405 32.15H38.7905L38.0405 30.55L35.8905 26.6H34.3905V34ZM44.7207 34.14C46.5307 34.14 47.5807 33.13 47.5807 30.68V26.6H46.1607V30.81C46.1607 32.34 45.5907 32.86 44.7207 32.86C43.8507 32.86 43.3107 32.34 43.3107 30.81V26.6H41.8407V30.68C41.8407 33.13 42.9107 34.14 44.7207 34.14ZM49.3612 34H50.6812V30.91C50.6812 30.21 50.5712 29.18 50.4912 28.48H50.5312L51.1312 30.22L52.2712 33.34H53.1212L54.2612 30.22L54.8712 28.48H54.9212C54.8412 29.18 54.7212 30.21 54.7212 30.91V34H56.0712V26.6H54.4312L53.2012 30.07C53.0512 30.53 52.9212 31.01 52.7512 31.49H52.7112C52.5512 31.01 52.4212 30.53 52.2512 30.07L50.9912 26.6H49.3612V34Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1618_59813",
    x: 0.366211,
    y: 1.18204,
    width: 61.4922,
    height: 61.6346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1618_59813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1618_59813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1618_59813",
    x1: 9,
    y1: 8.5,
    x2: 53,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55D1B4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipPlatinumMain);
export default __webpack_public_path__ + "static/media/image__membership-platinum--main.d33322a27f82a5a2b8ef46a523c98bd8.svg";
export { ForwardRef as ReactComponent };